export class PontoFidelidade{
  id: number;
  regra: number;
  inicio: number;
  fim: number;
  pontos: number;
  validade: number;
}
